export const bus_data = [
  {
    id: '1',
    make: 'Mellor',
    model: 'Maxima',
    bus_type: 'Coach',
    gvm: 7200,
    passenger_capacity: 30,
    passenger_max_for_comparison: 0,
    fuel_type: 'Diesel',
    power_max_kw: 0,
    battery_kwh: 275,
    range_km: 820,
    fuel_efficiency_km_l: 0.31,
    charging: 0,
    charge_time_mins: 0,
    battery_warranty_years: 0,
    purchase_price_pound: 250000,
  },
  {
    id: '2',
    make: 'ADL',
    model: 'Enviro200',
    bus_type: 'Single Decker',
    gvm: 14440,
    passenger_capacity: 46,
    passenger_max_for_comparison: 0,
    fuel_type: 'Diesel',
    power_max_kw: 187,
    battery_kwh: 220,
    range_km: 935,
    fuel_efficiency_km_l: 0.24,
    charging: 0,
    charge_time_mins: 0,
    battery_warranty_years: 0,
    purchase_price_pound: 192506,
  },
  {
    id: '3',
    make: 'ADL',
    model: 'Enviro400',
    bus_type: 'Double Decker',
    gvm: 18000,
    passenger_capacity: 86,
    passenger_max_for_comparison: 0,
    fuel_type: 'Diesel',
    power_max_kw: 187,
    battery_kwh: 275,
    range_km: 820,
    fuel_efficiency_km_l: 0.33,
    charging: 0,
    charge_time_mins: 0,
    battery_warranty_years: 0,
    purchase_price_pound: 250000,
  },
  {
    id: '4',
    make: 'Irizar',
    model: 'ie bus 10.8m',
    bus_type: 'Single decker',
    gvm: 20000,
    passenger_capacity: 63,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 180,
    battery_kwh: 350,
    range_km: 250,
    fuel_efficiency_km_l: 1.01,
    charging: 150,
    charge_time_mins: 140,
    battery_warranty_years: 0,
    purchase_price_pound: 399000,
  },
  {
    id: '5',
    make: 'Irizar',
    model: 'ie bus 12m',
    bus_type: 'Single decker',
    gvm: 21200,
    passenger_capacity: 80,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 180,
    battery_kwh: 350,
    range_km: 250,
    fuel_efficiency_km_l: 1.01,
    charging: 150,
    charge_time_mins: 140,
    battery_warranty_years: 0,
    purchase_price_pound: 399000,
  },
  {
    id: '6',
    make: 'Irizar',
    model: 'ie bus 15m',
    bus_type: 'Single decker',
    gvm: 26500,
    passenger_capacity: 105,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 235,
    battery_kwh: 525,
    range_km: 400,
    fuel_efficiency_km_l: 1.01,
    charging: 200,
    charge_time_mins: 160,
    battery_warranty_years: 0,
    purchase_price_pound: 399000,
  },
  {
    id: '7',
    make: 'Irizar',
    model: 'ie bus 18m',
    bus_type: 'Single decker',
    gvm: 30500,
    passenger_capacity: 151,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 235,
    battery_kwh: 525,
    range_km: 400,
    fuel_efficiency_km_l: 1.12,
    charging: 200,
    charge_time_mins: 160,
    battery_warranty_years: 0,
    purchase_price_pound: 475000,
  },
  {
    id: '8',
    make: 'Beulas',
    model: 'Jewel E',
    bus_type: 'Double decker',
    gvm: 19000,
    passenger_capacity: 88,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 400,
    battery_kwh: 548,
    range_km: 400,
    fuel_efficiency_km_l: 1.12,
    charging: 150,
    charge_time_mins: 220,
    battery_warranty_years: 5,
    purchase_price_pound: 485000,
  },
  {
    id: '9',
    make: 'Higer',
    model: 'Steed',
    bus_type: 'Single decker',
    gvm: 12400,
    passenger_capacity: 48,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 0,
    battery_kwh: 174,
    range_km: 300,
    fuel_efficiency_km_l: 1.01,
    charging: 135,
    charge_time_mins: 80,
    battery_warranty_years: 0,
    purchase_price_pound: 399000,
  },
  {
    id: '10',
    make: 'Higer',
    model: 'Azure',
    bus_type: 'Single decker',
    gvm: 13200,
    passenger_capacity: 72,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 0,
    battery_kwh: 350,
    range_km: 370,
    fuel_efficiency_km_l: 1.01,
    charging: 200,
    charge_time_mins: 105,
    battery_warranty_years: 0,
    purchase_price_pound: 399000,
  },
  {
    id: '11',
    make: 'Proterra',
    model: 'ZX5 Max',
    bus_type: 'Single decker',
    gvm: 19800,
    passenger_capacity: 40,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 250,
    battery_kwh: 675,
    range_km: 440,
    fuel_efficiency_km_l: 1.01,
    charging: 147,
    charge_time_mins: 275,
    battery_warranty_years: 12,
    purchase_price_pound: 450000,
  },
  {
    id: '12',
    make: 'BYD ADL',
    model: 'Enviro200EV',
    bus_type: 'Single decker',
    gvm: 18700,
    passenger_capacity: 80,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 180,
    battery_kwh: 348,
    range_km: 256,
    fuel_efficiency_km_l: 1.1,
    charging: 102,
    charge_time_mins: 205,
    battery_warranty_years: 0,
    purchase_price_pound: 399000,
  },
  {
    id: '13',
    make: 'BYD ADL',
    model: 'Enviro400EV',
    bus_type: 'Double decker',
    gvm: 19200,
    passenger_capacity: 72,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 300,
    battery_kwh: 382,
    range_km: 256,
    fuel_efficiency_km_l: 1.12,
    charging: 112,
    charge_time_mins: 205,
    battery_warranty_years: 0,
    purchase_price_pound: 456000,
  },
  {
    id: '14',
    make: 'Wrightbus',
    model: 'Streetdeck Electroliner BEV',
    bus_type: 'Double decker',
    gvm: 19500,
    passenger_capacity: 94,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 280,
    battery_kwh: 454,
    range_km: 320,
    fuel_efficiency_km_l: 0.75,
    charging: 150,
    charge_time_mins: 185,
    battery_warranty_years: 8,
    purchase_price_pound: 510000,
  },
  {
    id: '15',
    make: 'Caetano',
    model: 'e.City Gold',
    bus_type: 'Single decker',
    gvm: 17950,
    passenger_capacity: 87,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 180,
    battery_kwh: 385,
    range_km: 300,
    fuel_efficiency_km_l: 0.93,
    charging: 150,
    charge_time_mins: 155,
    battery_warranty_years: 0,
    purchase_price_pound: 399000,
  },
  {
    id: '16',
    make: 'SCANIA',
    model: 'Fencer Electric',
    bus_type: 'Single decker',
    gvm: 0,
    passenger_capacity: 74,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 250,
    battery_kwh: 330,
    range_km: 0,
    fuel_efficiency_km_l: 1.01,
    charging: 0,
    charge_time_mins: 0,
    battery_warranty_years: 0,
    purchase_price_pound: 399000,
  },
  {
    id: '17',
    make: 'Mellor',
    model: 'Orion-E',
    bus_type: 'Single decker',
    gvm: 5000,
    passenger_capacity: 16,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 96,
    battery_kwh: 92,
    range_km: 160,
    fuel_efficiency_km_l: 1.12,
    charging: 22,
    charge_time_mins: 250,
    battery_warranty_years: 0,
    purchase_price_pound: 450000,
  },
  {
    id: '18',
    make: 'Switch Mobility',
    model: 'Metrodecker',
    bus_type: 'Double decker',
    gvm: 18000,
    passenger_capacity: 99,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 250,
    battery_kwh: 389,
    range_km: 344,
    fuel_efficiency_km_l: 1.14,
    charging: 100,
    charge_time_mins: 235,
    battery_warranty_years: 0,
    purchase_price_pound: 485000,
  },
  {
    id: '19',
    make: 'Switch Mobility',
    model: 'Metrocity',
    bus_type: 'Single decker',
    gvm: 13000,
    passenger_capacity: 60,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 250,
    battery_kwh: 260,
    range_km: 304,
    fuel_efficiency_km_l: 1.01,
    charging: 100,
    charge_time_mins: 155,
    battery_warranty_years: 0,
    purchase_price_pound: 355000,
  },
  {
    id: '20',
    make: 'Switch Mobility',
    model: 'Solo',
    bus_type: 'Single decker',
    gvm: 11300,
    passenger_capacity: 58,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 150,
    battery_kwh: 138,
    range_km: 155,
    fuel_efficiency_km_l: 1.01,
    charging: 50,
    charge_time_mins: 165,
    battery_warranty_years: 0,
    purchase_price_pound: 365000,
  },
  {
    id: '21',
    make: 'Yutong',
    model: 'E10',
    bus_type: 'Single decker',
    gvm: 19500,
    passenger_capacity: 70,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 350,
    battery_kwh: 422,
    range_km: 370,
    fuel_efficiency_km_l: 0.84,
    charging: 150,
    charge_time_mins: 170,
    battery_warranty_years: 0,
    purchase_price_pound: 399000,
  },
  {
    id: '22',
    make: 'Yutong',
    model: 'E12',
    bus_type: 'Single decker',
    gvm: 19500,
    passenger_capacity: 70,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 350,
    battery_kwh: 422,
    range_km: 370,
    fuel_efficiency_km_l: 0.84,
    charging: 150,
    charge_time_mins: 170,
    battery_warranty_years: 0,
    purchase_price_pound: 399000,
  },
  {
    id: '24',
    make: 'Yutong',
    model: 'ABe13',
    bus_type: 'Single decker',
    gvm: 0,
    passenger_capacity: 110,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 350,
    battery_kwh: 258,
    range_km: 400,
    fuel_efficiency_km_l: 1.01,
    charging: 120,
    charge_time_mins: 140,
    battery_warranty_years: 0,
    purchase_price_pound: 399000,
  },
  {
    id: '25',
    make: 'Yutong',
    model: 'TCe12',
    bus_type: 'Coach',
    gvm: 0,
    passenger_capacity: 50,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 350,
    battery_kwh: 281,
    range_km: 400,
    fuel_efficiency_km_l: 1.01,
    charging: 120,
    charge_time_mins: 140,
    battery_warranty_years: 8,
    purchase_price_pound: 399000,
  },
  {
    id: '26',
    make: 'Solaris',
    model: 'Urbino 18 electric',
    bus_type: 'Single decker',
    gvm: 0,
    passenger_capacity: 120,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 240,
    battery_kwh: 550,
    range_km: 300,
    fuel_efficiency_km_l: 1.12,
    charging: 0,
    charge_time_mins: 0,
    battery_warranty_years: 0,
    purchase_price_pound: 475000,
  },
  {
    id: '27',
    make: 'Volvo',
    model: '7900 Electric 12m',
    bus_type: 'Single decker',
    gvm: 19500,
    passenger_capacity: 95,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 200,
    battery_kwh: 470,
    range_km: 435,
    fuel_efficiency_km_l: 1.08,
    charging: 150,
    charge_time_mins: 190,
    battery_warranty_years: 0,
    purchase_price_pound: 399000,
  },
  {
    id: '28',
    make: 'Volvo',
    model: '7900 Electric 18m',
    bus_type: 'Single decker',
    gvm: 30000,
    passenger_capacity: 145,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 400,
    battery_kwh: 565,
    range_km: 504,
    fuel_efficiency_km_l: 1.12,
    charging: 150,
    charge_time_mins: 225,
    battery_warranty_years: 0,
    purchase_price_pound: 475000,
  },
  {
    id: '29',
    make: 'Volvo',
    model: 'BZL Electric',
    bus_type: 'Single decker',
    gvm: 19500,
    passenger_capacity: 86,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 200,
    battery_kwh: 470,
    range_km: 345,
    fuel_efficiency_km_l: 1.08,
    charging: 150,
    charge_time_mins: 190,
    battery_warranty_years: 0,
    purchase_price_pound: 399000,
  },
  {
    id: '30',
    make: 'Volvo',
    model: 'BZL Electric',
    bus_type: 'Double decker',
    gvm: 19500,
    passenger_capacity: 86,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 200,
    battery_kwh: 470,
    range_km: 345,
    fuel_efficiency_km_l: 1.09,
    charging: 150,
    charge_time_mins: 190,
    battery_warranty_years: 0,
    purchase_price_pound: 485000,
  },
  {
    id: '31',
    make: 'Wrightbus',
    model: 'GB Kite Electroliner BEV',
    bus_type: 'Single decker',
    gvm: 19500,
    passenger_capacity: 82,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 280,
    battery_kwh: 567,
    range_km: 400,
    fuel_efficiency_km_l: 1.01,
    charging: 150,
    charge_time_mins: 230,
    battery_warranty_years: 0,
    purchase_price_pound: 399000,
  },
  {
    id: '32',
    make: 'Mellor',
    model: 'Sigma Range 10m',
    bus_type: 'Single decker',
    gvm: 16500,
    passenger_capacity: 54,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electricity',
    power_max_kw: 0,
    battery_kwh: 260,
    range_km: 177,
    fuel_efficiency_km_l: 1.2,
    charging: 100,
    charge_time_mins: 155,
    battery_warranty_years: 8,
    purchase_price_pound: 399000,
  },
]

export const beb_yearly_maintenance_cost_index: any = {
  '2022': '1',
  '2023': '0.9756',
  '2024': '0.9512',
  '2025': '0.9268',
  '2026': '0.9024',
  '2027': '0.878',
  '2028': '0.8536',
  '2029': '0.8292',
  '2030': '0.8048',
  '2031': '0.7804',
  '2032': '0.756',
  '2033': '0.7316',
  '2034': '0.7072',
  '2035': '0.6828',
  '2036': '0.6584',
  '2037': '0.634',
  '2038': '0.634',
  '2039': '0.634',
  '2040': '0.634',
  '2041': '0.634',
  '2042': '0.634',
  '2043': '0.634',
  '2044': '0.634',
  '2045': '0.634',
  '2046': '0.634',
  '2047': '0.634',
  '2048': '0.634',
  '2049': '0.634',
  '2050': '0.634',
  '2051': '0.634',
  '2052': '0.634',
  '2053': '0.634',
  '2054': '0.634',
  '2055': '0.634',
  '2056': '0.634',
  '2057': '0.634',
  '2058': '0.634',
  '2059': '0.634',
  '2060': '0.634',
  '2061': '0.634',
}

export const diesel_yearly_maintenance_cost_index: any = {
  '2022': '1.00',
  '2023': '1.00',
  '2024': '1.00',
  '2025': '1.00',
  '2026': '1.00',
  '2027': '1.00',
  '2028': '1.00',
  '2029': '1.00',
  '2030': '1.00',
  '2031': '1.00',
  '2032': '1.00',
  '2033': '1.00',
  '2034': '1.00',
  '2035': '1.00',
  '2036': '1.00',
  '2037': '1.00',
  '2038': '1.00',
  '2039': '1.00',
  '2040': '1.00',
  '2041': '1.00',
  '2042': '1.00',
  '2043': '1.00',
  '2044': '1.00',
  '2045': '1.00',
  '2046': '1.00',
  '2047': '1.00',
  '2048': '1.00',
  '2049': '1.00',
  '2050': '1.00',
  '2051': '1.00',
  '2052': '1.00',
  '2053': '1.00',
  '2054': '1.00',
  '2055': '1.00',
  '2056': '1.00',
  '2057': '1.00',
  '2058': '1.00',
  '2059': '1.00',
  '2060': '1.00',
  '2061': '1.00',
}

export const battery_yearly_cost_index: any = {
  '2022': '1.00',
  '2023': '0.71',
  '2024': '0.64',
  '2025': '0.59',
  '2026': '0.53',
  '2027': '0.48',
  '2028': '0.44',
  '2029': '0.40',
  '2030': '0.40',
  '2031': '0.40',
  '2032': '0.40',
  '2033': '0.40',
  '2034': '0.40',
  '2035': '0.40',
  '2036': '0.40',
  '2037': '0.40',
  '2038': '0.40',
  '2039': '0.40',
  '2040': '0.40',
  '2041': '0.40',
  '2042': '0.40',
  '2043': '0.40',
  '2044': '0.40',
  '2045': '0.40',
  '2046': '0.40',
  '2047': '0.40',
  '2048': '0.40',
  '2049': '0.40',
  '2050': '0.40',
  '2051': '0.40',
  '2052': '0.40',
  '2053': '0.40',
  '2054': '0.40',
  '2055': '0.40',
  '2056': '0.40',
  '2057': '0.40',
  '2058': '0.40',
  '2059': '0.40',
  '2060': '0.40',
  '2061': '0.40',
}

export const residual_battery_yearly_cost_index: any = {
  '2022': '1.00',
  '2023': '0.71',
  '2024': '0.64',
  '2025': '0.59',
  '2026': '0.53',
  '2027': '0.48',
  '2028': '0.44',
  '2029': '0.40',
  '2030': '0.40',
  '2031': '0.40',
  '2032': '0.40',
  '2033': '0.40',
  '2034': '0.40',
  '2035': '0.40',
  '2036': '0.40',
  '2037': '0.40',
  '2038': '0.40',
  '2039': '0.40',
  '2040': '0.40',
  '2041': '0.40',
  '2042': '0.40',
  '2043': '0.40',
  '2044': '0.40',
  '2045': '0.40',
  '2046': '0.40',
  '2047': '0.40',
  '2048': '0.40',
  '2049': '0.40',
  '2050': '0.40',
  '2051': '0.40',
  '2052': '0.40',
  '2053': '0.40',
  '2054': '0.40',
  '2055': '0.40',
  '2056': '0.40',
  '2057': '0.40',
  '2058': '0.40',
  '2059': '0.40',
  '2060': '0.40',
  '2061': '0.40',
}
